module.exports = __webpack_public_path__ + "media/images/iconbox/icon2-1d01a8ddb99054157b0cdb4e7e9cbc86.png";